import {IRowData} from '@/lib/types/common-types';
import TableRow from './TableRow';

export default function DataTable({
                                      tableRowData,
                                      data,
                                      ID
                                  }: {
    data: Object,
    tableRowData: IRowData[];
    ID: string;
}) {

    // Generate a random string for the key to ensure uniqueness
         return (
        <table className="w-full data-table">
            <tbody>
            {tableRowData.map((rowData, index) => (
                <TableRow key={ID + "-" + index} {...rowData} />
            ))}
            </tbody>
        </table>
    );
}
